import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
function DistributedContentIcon(_ref) {
  var type = _ref.type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var label = type === 'playlist' ? 'content_type_distributed_playlist' : 'content_type_distributed_asset';
  return /*#__PURE__*/React.createElement(Icon, _extends({
    name: "share",
    "aria-label": t(label)
  }, otherProps));
}
export default DistributedContentIcon;